
import { Icon } from './Icon.tsx';

const NativeButton = 'button';

interface FilterPillOption<T extends string> {
    value: T;
    label: string;
    icon?: string;
    count?: number;
    color?: 'gray' | 'purple' | 'blue' | 'green' | 'amber' | 'red';
}

interface FilterPillsProps<T extends string> {
    options: FilterPillOption<T>[];
    value: T;
    onChange: (value: T) => void;
    className?: string;
}

const colorClasses = {
    gray: 'bg-gray-500 text-white shadow-md',
    purple: 'bg-purple-500 text-white shadow-md',
    blue: 'bg-blue-500 text-white shadow-md',
    green: 'bg-green-500 text-white shadow-md',
    amber: 'bg-amber-500 text-white shadow-md',
    red: 'bg-red-500 text-white shadow-md',
};

export function FilterPills<T extends string>({ 
    options, 
    value, 
    onChange,
    className = ''
}: FilterPillsProps<T>) {
    return (
        <div className={`flex flex-wrap gap-2 ${className}`}>
            {options.map(({ value: optValue, label, icon, count, color = 'gray' }) => {
                const isActive = value === optValue;
                
                return (
                    <NativeButton
                        type="button"
                        key={optValue}
                        onClick={() => onChange(optValue)}
                        className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 font-medium text-sm transition-all ${isActive
                                ? colorClasses[color]
                                : 'bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700'
                            }
                        `}
                        aria-pressed={isActive}
                        aria-label={`Filter by ${label}${count !== undefined ? ` (${count} items)` : ''}`}
                    >
                        {icon ? <Icon name={icon} size="sm" /> : null}
                        {label}
                        {count !== undefined && (
                            <span className="ml-0.5 text-xs opacity-75">
                                ({count})
                            </span>
                        )}
                    </NativeButton>
                );
            })}
        </div>
    );
}
